import { IResolvers as ICoreResolvers, IClientService } from '@workbench-stack/core';
import { copyTextToClipboard } from '@workbench-stack/components';

const contextMenuResolvers: (services: () => IClientService) => ICoreResolvers = (services) => {
    return ({
        Mutation: {
            showContextMenu: (_, args, context) => {
                return services().contextMenuService.showContextMenu(args.delegate);
            },
            hideContextMenu: (_, args, context) => {
                return services().contextMenuService.hideContextMenu();
            },
            runMenuAction: (_, args, context) => {
                return services().contextMenuService.runMenuAction(args.argument);
            },
            copy: (_, args, context) => {
                copyTextToClipboard(args.value);
                return true;
            },
        },
    });
};

export { contextMenuResolvers };
